import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { AppService } from "../../core/services/app.service";
import { presetStatus, presetType } from "../constants/preset-constant";
import * as moment from "moment";

@Injectable({
    providedIn: 'root'
})

export class PresetService {
    constructor(public http: HttpClient) {
    }

    public static presetAPI = AppService.getApiUrl() + '/api/presets/';
    public static battleRatingAPI = AppService.getApiUrl() + '/api/battleRatings/';

    createPreset(data) {
        return this.http.post(PresetService.presetAPI, data);
    }
    
    updatePreset(data) {
        return this.http.put(PresetService.presetAPI + data.id, data);
    }
    
    addPoint(data) {
        return this.http.post(PresetService.battleRatingAPI + 'addPoint', data);
    }
    
    getBattlePresetResult(presetId) {
        return this.http.get(PresetService.battleRatingAPI + `result?presetId=${presetId}`);
    }
    
    vote(model) {
        return this.http.post(PresetService.battleRatingAPI, model);
    }
    
    deletePreset(id) {
        return this.http.delete(PresetService.presetAPI + id);
    }
    
    preview(ids) {
        return this.http.get(AppService.getApiUrl() + 'api/presets/ids?=' + ids);
    }
    
    getAvailableBattle(groupIds) {
        const queryObject: Record<string, any> = {
            "where":
                {
                    "and": [
                        {
                            "or": [
                                {
                                    "and": [
                                        {"type": presetType.Battle},
                                        {"status": presetStatus.COMPLETED},
                                        {"endTime": {"between": [moment().subtract(1,'d'), moment()]}}
                                    ]
                                },
                                {
                                    "and": [
                                        {"type": presetType.Battle},
                                        {"status": presetStatus.IN_PROGRESS}
                                    ]
                                }]
                        },
                        {
                            or: [
                                {
                                    groupId : null
                                }
                            ]
                        }
                    ]
                },
            "order": "status DESC, endTime",
            "include": ['group']
        };
        if (groupIds.length) {
            queryObject.where.and[1].or.push({
                groupId : {
                    inq: groupIds
                }
            })
        }
        
        const filter = encodeURIComponent(JSON.stringify(queryObject));
        const url = `${PresetService.presetAPI}?filter=${filter}`;
        
        return this.http.get(url);
    }
    
    getPresetDetail(id) {
        return this.http.get(PresetService.presetAPI + id);
    }
}
